import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import {
  ContactModalData,
  ModalContactoFacultadComponent
} from '../modal-contacto-facultad/modal-contacto-facultad.component';

@Component({
  selector: 'app-facultades-contacto',
  standalone: true,
  imports: [CommonModule, ModalContactoFacultadComponent],
  templateUrl: './facultades-contacto.component.html',
  styleUrl: './facultades-contacto.component.scss'
})
export class FacultadesContactoComponent {
  @Input() info:any;
  isContactModalOpen = false;

  get contactModalData(): ContactModalData | undefined {
    return this.info?.contactModal || this.info?.contactModalData;
  }

  get contactModalColor(): string {
    return this.info?.venue?.color || '#6849B5';
  }

  openContactModal(): void {
    this.isContactModalOpen = true;
  }

  closeContactModal(): void {
    this.isContactModalOpen = false;
  }

}
